import {TABS_ATTENDANCES_MAIN_TABS_MODEL} from "../Requested/Model/Models";
import CustomTabContainer from "../../../../components/CustomTabContainer";
import {useState} from "react";
import CustomTab from "../../../../components/CustomTab";
import ReservationAttendances from "./ReservationAttendances";
import ReservationWhiteList from "./ReservationWhiteList";
/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const AttendancesMainTabs = ({
    t,
    statusId,
    getInvitationsTab,
    modified,
    setModified,
    selectedTabId,
    setSelectedTabId,
    currentTab,
    DEV,
    permission,
    isOverdue,
    containerHeight
}) => {
    const [selectedTab, setSelectedTab] = useState(TABS_ATTENDANCES_MAIN_TABS_MODEL.ATTENDEES.key);

    return (
        <div className="border-full-shades-300 border-radius-8px p-16px overflow-hidden d-flex flex-column minh-645px" style={{height:containerHeight }}>
            <CustomTabContainer
                activeTab={selectedTab}
                setActiveTab={(e) => {
                    setSelectedTab(e);
                }}
                className="border-0 px-0"
                paddingClass=''
            >
                {Object.values(TABS_ATTENDANCES_MAIN_TABS_MODEL).map((item) => (
                    <CustomTab
                        key={item.key}
                        id={item.key}
                        title={t(item.translation)}
                        icon={item?.icon}
                        selected={selectedTab === item.key}
                        onClick={() => {
                            setSelectedTab(item.key)
                        }}
                    />
                ))}
            </CustomTabContainer>

            <div className="flex-grow-1 min-h-0 d-flex flex-column">
                {selectedTab === TABS_ATTENDANCES_MAIN_TABS_MODEL.ATTENDEES.key ? (
                    <ReservationAttendances
                        t={t}
                        statusId={statusId}
                        getInvitationsTab={getInvitationsTab}
                        modified={modified}
                        setModified={setModified}
                        selectedTabId={selectedTabId}
                        setSelectedTabId={setSelectedTabId}
                        currentTab={currentTab}
                        DEV={DEV}
                        permission={permission}
                        isOverdue={isOverdue}
                    />
                ) : (
                    <ReservationWhiteList/>
                )}
            </div>

        </div>
    );

}

export default AttendancesMainTabs
